import { Card, CardContent, CardHeader, Divider, Typography, Button, Box, Skeleton, } from "@mui/material";
import { Check, FileCopyOutlined } from "@mui/icons-material";
import copy from 'copy-to-clipboard';
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useGetAdminSettingsQuery } from "src/_api/adminApi";
import { useSelector } from "react-redux";

export default function ReferralCommissionCard() {
  const { t } = useTranslation()

  const { profile } = useSelector((state) => state.entities.profile)

  const {
    data: settingsData,
    isLoading: settingsLoading,
  } = useGetAdminSettingsQuery()

  const link = `${window.origin}/auth/general/register?referringMerchant=${profile?.merchant?.id}`

  const [isCopied, setIsCopied] = useState(false)
  const handleClick = _ => {
    copy(link)
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 3000);
  }

  return (
    <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        title={t("Referral Commission")}
        action={
          <Button
            m={1}
            variant="contained"
            color="white"
            startIcon={isCopied ? <Check color="success" /> : <FileCopyOutlined />}
            size="small"
            onClick={handleClick}
            sx={{ textTransform: "none" }}
          >
            {t("Copy")}
          </Button>
        } />
      <Divider />
      <CardContent sx={{ flex: 1 }} >
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {t("referralCommissionDescription", { amount: settingsData?.referralCommission?.referringMerchantAmount, reward: settingsData?.referralCommission?.newMerchantAmount })}
        </Typography>
        {
          settingsLoading ?
            <Box sx={{ width: '100%' }}>
              <Skeleton variant="text" width="80%" />
              <Skeleton variant="rectangular" height={40} sx={{ mt: 2, borderRadius: 2 }} />
            </Box>
            :
            <bdi>
              <Box backgroundColor="#F4F6F8" p={1} borderRadius={2}>
                <Typography variant="subtitle2" sx={{ wordBreak: 'break-all' }}>
                  {link}
                </Typography>
              </Box>
            </bdi>
        }
      </CardContent>
      <Divider />
    </Card>
  );
};
